import { datahubAxiosClient, ENDPOINT_DETAILS } from 'constants/server/apiEndPoint';
import { useQuery } from '@tanstack/react-query';
import { INewsDto } from './dtos';

export const newsQueryKey = {
  all: ['all'] as const,
  getNews: (language: string) => [...newsQueryKey.all, 'getNews', language],
};

export const getNewsApi = (locale: string) => {
  const { data, isLoading } = useQuery({
    queryKey: newsQueryKey.getNews(locale),
    queryFn: async ({ signal }) => {
      let language = 'EN';

      if (locale.includes('da') || locale.includes('dk')) language = 'DA';
      if (locale.includes('sv') || locale.includes('se')) language = 'SV';
      if (locale.includes('no')) language = 'NO';
      if (locale.includes('vi')) language = 'VI';
      const response = await datahubAxiosClient.get<INewsDto[]>(ENDPOINT_DETAILS.getNews(language), {
        signal,
      });
      return response?.data || [];
    },
    enabled: !!locale,
  });

  return { data, isLoading };
};
